import { Box, Select, TextField } from "@mui/material";
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import { SelectChangeEvent } from '@mui/material/Select';
import { useApiUrl } from "@refinedev/core";
import { Edit } from "@refinedev/mui";
import { useForm } from "@refinedev/react-hook-form";
import { useCallback, useEffect, useState } from "react";
import { dataProvider } from "rest-data-provider";

export const FollowersSettingsEdit = () => {
    const {
        saveButtonProps,
        refineCore: { queryResult },
        register,
        formState: { errors },
    } = useForm();
    const data = queryResult?.data?.data;

    // badgeName
    const apiUrl = useApiUrl();
    const [badgeId, setBadgeId] = useState<string>("");
    const [badgeNameArr, setBadgeNameArr] = useState<{value: string; type: string}[]>([]);
    const badgeNameDataFun = useCallback(() => {
        return dataProvider(apiUrl)
        .getList({resource: "badge"})
        .then((res) => {
            if (res?.data && res?.data.length !== 0) {
                const arr = res.data.map((item: any) => {
                    return {
                        value: item?.id,
                        type: item?.name,
                    }
                });
                setBadgeNameArr(arr);
            }
            return res?.data;
        });
    }, [apiUrl]);
    const handleChange = (event: SelectChangeEvent) => {
        setBadgeId(event.target.value as string);
    }
    useEffect(() => {
        badgeNameDataFun();
    },[badgeNameDataFun]);

    const [createdAt, setCreatedAt] = useState("");
    const [updatedAt, setUpdatedAt] = useState("");
    const [gte, setGte] = useState("");
    useEffect(() => {
        if (data) {
            setBadgeId(data?.badgeId);
            setCreatedAt(new Date(data?.createdAt).toLocaleString());
            setUpdatedAt(new Date(data?.updatedAt).toLocaleString());
            setGte(data?.gte);
        }
    },[data]);

    return (
        <Edit saveButtonProps={saveButtonProps}>
            <Box
                component="form"
                sx={{ display: "flex", flexDirection: "column" }}
                autoComplete="off"
            >
                <FormControl fullWidth style={{marginTop: "10px", marginBottom: "10px"}}>
                    <InputLabel id="badgeId">BadgeName</InputLabel>
                    <Select
                        {...register("badgeId", {
                        })}
                        labelId="badgeId"
                        value={badgeId}
                        label="BadgeName"
                        onChange={handleChange}
                    >
                        {
                        badgeNameArr.map((item) => {
                            return <MenuItem key={item.value} value={item.value}>{item.type}</MenuItem>
                        })
                    }
                    </Select>
                </FormControl>
                <TextField
                    {...register("gte", {
                        required: "This field is required",
                        validate: () => {
                            var intRegex = /^\d+$/; 
                            return intRegex.test(gte);
                        }
                    })}
                    error={!!(errors as any)?.gte}
                    helperText={"Gte is required and gte must be non-negative integer!"}
                    margin="normal"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    type="number"
                    label="Gte"
                    name="gte"
                    value={gte}
                    onChange={(e) => {
                        setGte(e.target.value);
                    }}
                />
                <TextField
                    {...register("name", {
                        required: "This field is required",
                    })}
                    error={!!(errors as any)?.name}
                    helperText={(errors as any)?.name?.message}
                    margin="normal"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    type="text"
                    label="Name"
                    name="name"
                />
                <TextField
                    {...register("description", {
                        required: "This field is required",
                    })}
                    error={!!(errors as any)?.description}
                    helperText={(errors as any)?.description?.message}
                    margin="normal"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    type="text"
                    label="Description"
                    name="description"
                />
                <TextField
                    {...register("createdAt", {
                        required: "This field is required",
                    })}
                    error={!!(errors as any)?.createdAt}
                    helperText={(errors as any)?.createdAt?.message}
                    margin="normal"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    label="CreatedAt"
                    name="createdAt"
                    value={createdAt}
                    disabled
                />
                <TextField
                    {...register("updatedAt", {
                        required: "This field is required",
                    })}
                    error={!!(errors as any)?.updatedAt}
                    helperText={(errors as any)?.updatedAt?.message}
                    margin="normal"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    label="UpdatedAt"
                    name="updatedAt"
                    value={updatedAt}
                    disabled
                />
            </Box>
        </Edit>
    );
};
